export default "/images/vendor/flag-icon-css/flags/1x1/ws.svg?81cbff3db85ab05a4ac816a8ab047727";